import { sto } from "./InshData";
import dataF from "../Server/dataF.json";

const tbReGitData = {
  /*other:true,*/ // out
  wait: true,
  PermissionsScreen1: true,
  // Currencies: true,
  /* Permissions:true,PermissionsCurr:true, */ // out
  // groups: true,
  // FavGroup: true,
  // View_CurrencieUnit: true,
  // View_CurrenciesToInv: true,
  Step_inv2: true,
  Users: true,
  Foundations: true,

  types: true,
  Safes: true,
  Stocks: true, // Error // out
  Banks: true,
  // Customers: true,
  salesmen: true,
  costcenters: true,
  Branches: true,
  Employees: true,
  typesFltr: true,
  PermissionApp: true,
  omlat: true,
  parms: {
    // sProcTypeInvProc:"02", // out
    ibranchid: sto.branchi,
    iempid: sto.empi,
    iuserid: sto.idi,
    // groupsSub: true,
    scurrenciestype: "I",
    scurrencieShow: "Fav",
    safe: sto.safe,
    currShow: "M",
    igroupid: -1,
    currType: 2, // out
    takei: 10,
    sSearch: "",
    tname:"fromLogin"
  },
  autos: {
    Users: true,
    Branches: true,
    // Safes: true,
    // Stocks: true,
    // Banks: true,
    Employees: true,
    salesmens: true,
    costcenters: true,
    // FavGroup: true,
    // groups: true,
  },
  parmsArr: [
    // {
    //   grid:/*sales*/
    //   [
    { iformid: dataF[111].id } /* 0 charts p */,
    { iformid: dataF[47].id } /* 1 sal p */,
    { iformid: dataF[49].id } /* 2 salRet p */,
    { iformid: dataF[46].id } /* 3 purch p */,
    { iformid: dataF[48].id } /* 4 purchRet p */,
    { iformid: dataF[50].id } /* 5 safe p */,
    { iformid: dataF[109].id } /* 6 evrDay eqfDay p */,
    { iformid: dataF[100].id } /* 7 tafseel activ p */,
    { iformid: dataF[88].id } /* 8 safJrd p */,
    { iformid: dataF[38].id } /* 9 custAcc p */,
    { iformid: dataF[76].id } /* 10 acc p */,
    /* BasicData */
    /* T1 */
    { iformid: dataF[0].id } /* 11 found */,
    { iformid: dataF[2].id } /* 12 branch */,
    { iformid: dataF[12].id } /* 13 unit p */,
    { iformid: dataF[3].id } /* 14 item p */,
    { iformid: dataF[102].id } /* 15 itemGroup p */,
    { iformid: dataF[13].id } /* 16 taxGroup */,
    /* T2 */
    { iformid: dataF[2].id } /* 17 safes */,
    { iformid: dataF[5].id } /* 18 stocks */,
    { iformid: dataF[9].id } /* 19 bank */,
    { iformid: dataF[20].id } /* 20 centr */,
    { iformid: dataF[15].id } /* 21 omla */,
    { iformid: dataF[15].id } /* 22 accBook */,
    /* T3 */
    { iformid: dataF[40].id } /* 23 custGroup */,
    { iformid: dataF[43].id } /* 24 salesmen */,
    { iformid: dataF[43].id } /* 25 mokharg */,
    { iformid: dataF[6].id } /* 26 country */,
    { iformid: dataF[7].id } /* 27 city */,
    { iformid: dataF[8].id } /* 28 area */,
    /* T4 */
    { iformid: dataF[41].id } /* 29 mang */,
    { iformid: dataF[42].id } /* 30 dept */,
    { iformid: dataF[43].id } /* 31 job */,
    { iformid: dataF[16].id } /* 32 cardType */,

    { iformid: dataF[59].id } /* 33 salView p */,
    { iformid: dataF[73].id } /* 34 multiQ p */,
    { iformid: dataF[72].id } /* 35 multiS p */,
    { iformid: dataF[66].id } /* 36 sandQKh p */,
    { iformid: dataF[67].id } /* 37 sandSKh p */,
    { iformid: dataF[36].id } /* 38 addCust p */,
    { iformid: dataF[40].id } /* 39 groupCust p */,
    { iformid: dataF[68].id } /* 40 sandQD p */,
    { iformid: dataF[69].id } /* 41 sandSD p */,
    { iformid: dataF[74].id } /* 42 accountTree p */,
    { iformid: dataF[77].id } /* 43 accountRPT p */,
    { iformid: dataF[83].id } /* 44 restInsert p */,
    { iformid: dataF[84].id } /* 45 taxRPT p */,
    { iformid: dataF[39].id } /* 46 custPayTrans p */,
    { iformid: dataF[54].id } /* 47 saleByEmploy p */,
    { iformid: dataF[110].id } /* 48 saleAnalysis p */,
    { iformid: dataF[64].id } /* 49 profitMargin p */,
    { iformid: dataF[53].id } /* 50 saleProfit p */,
    { iformid: "20002" } /* 51 custBalance p */,
  ],
};

export { tbReGitData };
